import script from "./TrainUsersList.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainUsersList.vue?vue&type=script&setup=true&lang=js"

import "./TrainUsersList.vue?vue&type=style&index=0&id=7021a24c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7021a24c"]])

export default __exports__